module.exports = __webpack_public_path__ + "img/home.271d6a78.png";